<template>
    <vx-card title="Редактировать юридическое лицо" id="loader">
        <div class="vx-row mb-2">
            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.fio"
                        :danger="!!errors.fio"
                        :danger-text="errors.fio"
                        autocomplete="off"
                        label="ФИО (для физических лиц и ИП)"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.fullOpf"
                        :danger="!!errors.fullOpf"
                        :danger-text="errors.fullOpf"
                        autocomplete="off"
                        label="Организационно-правовая форма (ОПФ) и полное наименование."
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.individualAccountDescription"
                        :danger="!!errors.individualAccountDescription"
                        :danger-text="errors.individualAccountDescription"
                        autocomplete="off"
                        label="Описание контрагента"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.inn"
                        :danger="!!errors.inn"
                        :danger-text="errors.inn"
                        autocomplete="off"
                        label="ИНН"
                        class="mt-1 w-full required"
                    />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label">
                        Является оператором рекламной системы
                    </label>
                    <vs-checkbox 
                        class="mt-3" 
                        icon="check" 
                        color="rgb(38, 187, 174)"
                        v-model="item.isOpc">
                    </vs-checkbox>
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label">
                        Является рекламораспространителем
                    </label>
                    <vs-checkbox 
                        class="mt-3" 
                        icon="check" 
                        color="rgb(38, 187, 174)"
                        v-model="item.isPp">
                    </vs-checkbox>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.legalAddress"
                        :danger="!!errors.legalAddress"
                        :danger-text="errors.legalAddress"
                        autocomplete="off"
                        label="Полный адрес"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.legalAddressLocality"
                        :danger="!!errors.legalAddressLocality"
                        :danger-text="errors.legalAddressLocality"
                        autocomplete="off"
                        label="Населенный пункт"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.legalAddressPostcode"
                        :danger="!!errors.legalAddressPostcode"
                        :danger-text="errors.legalAddressPostcode"
                        autocomplete="off"
                        label="Почтоый индекс"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <label class="vs-input--label"> Форма собственности </label>
                    <v-select
                        :options="dicts.legalTypes"
                        label="description"
                        placeholder="Выберите форму"
                        class="w-full"
                        v-model="item.legalTypeId"
                        :reduce="a => a.id"
                        :clearable="false"
                    ></v-select>
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.ogrn"
                        :danger="!!errors.ogrn"
                        :danger-text="errors.ogrn"
                        autocomplete="off"
                        label="ОГРН"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.ogrnip"
                        :danger="!!errors.ogrnip"
                        :danger-text="errors.ogrnip"
                        autocomplete="off"
                        label="ОГРНИП"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.paymentNumber"
                        :danger="!!errors.paymentNumber"
                        :danger-text="errors.paymentNumber"
                        autocomplete="off"
                        label="Номер электронного средства платежа (для ин. физ. лиц)"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.phoneNumber"
                        :danger="!!errors.phoneNumber"
                        :danger-text="errors.phoneNumber"
                        autocomplete="off"
                        label="Абонентский номер мобильного телефона (для иностранных граждан — идентификатор платёжного средства)"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.postAddress"
                        :danger="!!errors.postAddress"
                        :danger-text="errors.postAddress"
                        autocomplete="off"
                        label="Почтовый адрес"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.postAddressLocality"
                        :danger="!!errors.postAddressLocality"
                        :danger-text="errors.postAddressLocality"
                        autocomplete="off"
                        label="Населенный пункт"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.postAddressPostcode"
                        :danger="!!errors.postAddressPostcode"
                        :danger-text="errors.postAddressPostcode"
                        autocomplete="off"
                        label="Почтоый индекс"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.regionNumber"
                        :danger="!!errors.regionNumber"
                        :danger-text="errors.regionNumber"
                        autocomplete="off"
                        label="Код страны регистрации в соответствии с ОКСМ"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.registrationNumber"
                        :danger="!!errors.registrationNumber"
                        :danger-text="errors.registrationNumber"
                        autocomplete="off"
                        label="Регистрационный номер или его аналог (для иностранных юридических лиц)"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.shortOpf"
                        :danger="!!errors.shortOpf"
                        :danger-text="errors.shortOpf"
                        autocomplete="off"
                        label="Организационно-правовая форма (ОПФ) и сокращенное наименование"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-1/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.taxId"
                        :danger="!!errors.taxId"
                        :danger-text="errors.taxId"
                        autocomplete="off"
                        label="Номер налогоплательщика или его аналог в стране регистрации"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-2/3">
                <div class="mt-1">
                    <vs-input
                        v-model="item.trustedPerson"
                        :danger="!!errors.trustedPerson"
                        :danger-text="errors.trustedPerson"
                        autocomplete="off"
                        label="Должность и ФИО лица, имеющего право без доверенности действовать от имени юридического лица"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.violationDescription"
                        :danger="!!errors.violationDescription"
                        :danger-text="errors.violationDescription"
                        autocomplete="off"
                        label="Сведения о несоблюдении требований к распространению рекламы в интернете"
                        class="mt-1 w-full"
                    />
                </div>
            </div>

            <div class="vx-col w-full">
                <div class="mt-1">
                    <vs-input
                        v-model="item.rsUrl"
                        :danger="!!errors.rsUrl"
                        :danger-text="errors.rsUrl"
                        autocomplete="off"
                        label="Сайт контрагента"
                        class="mt-1 w-full"
                    />
                </div>
            </div>
        </div>

        <platforms-block :items="item.platforms" :error="errors.platforms" @selectPlatforms="onSelectPlatforms($event)"></platforms-block>

        <vs-button class="mt-5 mr-2" color="success" @click="save()" type="filled"> Сохранить </vs-button>
        <vs-button class="mt-5" color="primary" @click="cancelEdit()" type="filled"> Отмена </vs-button>
    </vx-card>
</template>


<script>
import vSelect from 'vue-select';
import axios from 'axios';

import PlatformsBlock from './PlatformsBlock';

export default {
    name: 'organization-edit',
    props: ['id'],
    data() {
        return {
            item: {},
            form: {
            },
            dicts: {
                legalTypes: []
            },
            errors: {
                inn: '',
                platforms: '',
                rsUrl: ''
            }
        };
    },
    components: {
        'v-select': vSelect,
        PlatformsBlock
    },
    methods: {
        loadDicts() {
            this.axios
                .all([this.axios.get('organizations/dictionaries')])
                .then(
                    axios.spread((dicts) => {
                        this.dicts.legalTypes = dicts.data.legalTypes;
                    })
                )
                .catch((err) => {
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки справочников.',
                        color: 'danger'
                    });
                });
        },
        loadData() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            this.axios
                .all([this.axios.get('organizations/' + this.id)])
                .then(
                    axios.spread((item) => {
                        this.$vs.loading.close('#loader > .con-vs-loading');
                        this.item = item.data;
                        if (!this.item.platforms.length) {
                            this.item.platforms = [{}];
                        }
                    })
                )
                .catch((err) => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                    this.$vs.notify({
                        title: 'Ошибка!',
                        text: 'Ошибка загрузки юр. лица.',
                        color: 'danger'
                    });
                })
                .finally(() => {
                    this.$vs.loading.close('#loader > .con-vs-loading');
                });
        },
        save() {
            this.$vs.loading({
                container: '#loader',
                type: 'sound'
            });

            const platforms = this.item.platforms.filter(p => !!p.platformId);

            const params = Object.assign({}, this.item, { id: this.id, platforms });

            this.$axios({
                method: 'PUT',
                url: 'organizations/' + this.id,
                params: params,
                errors: this.errors,
                success: () => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    this.$vs.notify({
                        title: "Успешно обновлено",
                        text: "Юр. лицо успешно обновлено",
                        color: "success",
                    });
                    this.$router.push('/ord/organizations');
                },
                catch: (err) => {
                    this.$vs.loading.close("#loader > .con-vs-loading");
                    if (err.request.status == 422 && err.data.errors['']) {
                        const error = err.data.errors[''][0];
                        return this.$vs.notify({
                            title: 'Внимание!',
                            text: error,
                            color: 'danger'
                        });
                    }

                    return this.$vs.notify({
                        title: "Внимание!",
                        text: "Ошибка при редактировании юр. лица!",
                        color: "danger",
                    });
                }
            })
        },
        cancelEdit() {
            this.$router.push('/ord/organizations');
        },

        onSelectPlatforms(platforms) {
            this.item.platforms = platforms;
        }
    },
    mounted() {
        this.loadDicts();
        this.loadData();
    }
};
</script>

<style scoped>

</style>